import React from "react";
import Hero from "../../components/Hero";
import HeroImage from "../../../assets/images/New8.jpg";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";

const Blog3 = () => {
  const navigate = useNavigate();
  return (
    <div className="about-us-page">
      <Hero title="Blogs" backgroundImage={HeroImage} />
      <div className="primary-background-container-content">
        <div className="privacy-container">
          <h3>What Would Happen If I Could No Longer Work As A Medic?</h3>
          <p>
            There seems to be a bit of confusion out there about what sick pay
            you’re actually entitled to as a medic working in the NHS. Many
            assume that if you’re off on long-term sick, your income will just
            keep ticking along, sadly that’s not quite true.
          </p>
          <p>
            In this article we will take a deeper dive into what really happens
            and why it’s worth making sure you have the right protection in
            place for yourself and your family.
          </p>
          <p>
            <strong>
              What sick pay are NHS doctors & surgeons actually entitled to?
            </strong>
          </p>
          <p>
            If you’re signed off on long-term sick, your pay depends on your
            length of NHS service. You will receive 1 month full pay and 2
            months half pay in year one of your employment with the NHS, rising
            to a maximum of 6 months full pay and 6 months half pay after 5
            year’s service.
          </p>
          <p>
            At the end of your long-term sick leave, your income can stop
            altogether, and you could find yourself relying on Statutory Sick
            Pay (SSP) which is currently £118.75 per week.
          </p>
          <p>
            Compared to most employers, NHS long term sickness is a reasonably
            generous policy. But with doctors now expected to work until age 68,
            facing ever higher levels of stress and burnout (as reflected in the
            NHS Staff Survey), the odds of needing long-term sick leave at some
            point in your career are unfortunately increasing.
          </p>
          <p>
            <strong>What happens when your pay stops?</strong>
          </p>
          <p>
            It’s a question too few of us consider, what would happen if you
            were signed off work for months or even years?
          </p>
          <p>
            If your income suddenly reduced by half, or worse, stopped
            completely, how long could you continue to support yourself and your
            family?
          </p>
          <p>
            How many months could you keep up your mortgage or rent, pay the
            bills, or feed the kids?
          </p>
          <p>
            According to Aviva, customers who go on long-term sick leave are out
            of work for an average of 6 years and 9 months.
          </p>
          <p>
            For a hospital consultant to maintain their net pay over that
            period, you’d need a savings pot of around £425,000. That’s just to
            keep up with your existing lifestyle not to fund extras, future
            savings, your children’s education costs or even keep up with
            inflation.
          </p>
          <p>
            Most people underestimate their spending and overestimate how long
            their savings will last. Which is why the right type of protection
            isn’t just a safety net, it’s financial peace of mind.
          </p>
          <p>
            Two key lines of defence. There are two main types of cover that can
            protect you and your family against the financial impact of
            long-term illness or injury:
          </p>
          <p>
            <strong>Income Protection Policy (IPP) </strong> provides a monthly
            income if you’re unable to work due to illness or injury, this is
            typically 60% of your gross salary.
          </p>
          <p>
            <strong>Critical Illness Cover (CIC) </strong>pays a tax-free lump
            sum on diagnosis of a specified serious condition, such as cancer,
            heart attack, or stroke.
          </p>
          <p>
            These two forms of cover serve different purposes but complement
            each other. When used together, they can secure both your short-term
            income and your long-term financial stability.
          </p>
          <p>
            <strong>
              Income protection is your ongoing financial safety net
            </strong>
          </p>
          <p>
            Income Protection should be viewed as the foundation of your
            financial resilience. It’s designed to replace a portion of your
            income if you can’t work due to ill health paying up to 60% of your
            gross salary until you recover or reach State Pension Age (currently
            68).
          </p>
          <p>
            Because NHS medics have a relatively generous long term sick policy,
            premiums are often cheaper than for other professions. That’s
            because you can set a longer deferred period (the time between going
            off sick and when the policy starts paying).
          </p>
          <p>
            For example, an NHS doctor could select a specialist policy that
            allows for a deferred period of up to six months, aligning with the
            point at which full pay ends and then During the next six months on
            half pay, the policy can top up your income to around 60% of your
            gross salary. That’s roughly equivalent to your usual take-home pay
            for a consultant or registrar in the 40% tax band.
          </p>
          <p>
            After 12 months, when NHS pay stops completely, the Income
            Protection Policy continues to pay 60% of your salary for as long as
            needed right up to State Pension Age if necessary.
          </p>
          <p>
            IPP can provide a welcome safety net in a profession where physical
            and psychological pressures are part of daily life.
          </p>
          <p>
            <strong>
              Three levels of cover, do you know what you’re paying for.
            </strong>
          </p>
          <p>
            Not all policies are created equal. Income Protection comes with
            different levels of cover, and it’s vital to understand the
            distinction.
          </p>
          <p>
            1. Any Occupation: You’ll only be paid if you’re unable to do any
            job. In theory, if you could work in a hospital café or
            administrative role, you may not receive a payout.
          </p>
          <p>
            2. Specified Activities (ADLs): You’ll only be covered if you can’t
            perform a certain number often 3 “Activities of Daily Living” such
            as walking, bending, or lifting.
          </p>
          <p>
            3. Own Occupation: The most comprehensive and the most appropriate
            for doctors.
          </p>
          <p>
            This means if you’re unable to carry out your specific duties (for
            example, operating as a surgeon, working as an anaesthetist, or
            practising as a GP), the policy pays out. You won’t be expected to
            take on another role. For anyone working as a medic, “own
            occupation” cover is the most sensible choice.
          </p>
          <p>
            <strong>IPP offers ongoing cover, even after recovery</strong>
          </p>
          <p>
            Another major benefit of Income Protection is that it’s not a single
            event policy. As long as you keep up your premiums, your insurer
            can’t cancel your cover, even if you’ve claimed previously.
          </p>
          <p>
            So, if you recover, return to work, and then later need time off
            again, you’re still fully covered. Most policies also include a
            waiver of premium, meaning the insurer will cover your policy
            payments while you’re off sick and claiming benefits.
          </p>
          <p>
            <strong>
              Critical Illness Cover gives you the lump sum that buys you
              choices.
            </strong>
          </p>
          <p>
            Where Income Protection helps you maintain your income and level of
            existing wealth, Critical Illness Cover (CIC) provides flexibility
            and choice if something awful was to happpen.
          </p>
          <p>
            CIC pays a tax-free lump sum when you’re diagnosed with a serious
            illness or suffer a major injury listed in your policy. You decide
            the level of cover when you take out the policy, and the payout can
            be used however you wish.
          </p>
          <p>• Common uses include:</p>
          <p>• Paying off or reducing a mortgage</p>
          <p>• Funding home adaptations</p>
          <p>
            • Covering private medical treatment or care Investing to create a
            future income stream Supplementing retirement savings
          </p>
          <p>
            This becomes especially valuable when planning for later life. For
            example, once your Income Protection policy stops paying at 68, a
            critical illness payout could be used to provide additional
            retirement income through drawing down the investment or buying an
            annuity for lifelong payments to top up a reduced NHS pension.
          </p>
          <p>
            <stong>What do CIC policies cover</stong>
          </p>
          <p>
            Most CIC policies cover 40–50 critical conditions, these can include
            cancer, heart attack, stroke, multiple sclerosis, and organ failure.
            Many also offer partial payouts (usually 50%) for early-stage or
            less severe illnesses.
          </p>
          <p>
            There’s usually a survivor clause somewhere between 10–14 days,
            meaning you need to survive for that period after diagnosis before
            the payout is made. If death occurs before then, a life insurance
            policy would typically pay out instead.
          </p>
          <p>
            As always, cheaper policies may cover fewer conditions, so it’s
            worth reading the small print carefully or reviewing it with a
            financial adviser familiar with medical professionals.
          </p>
          <p>
            <stong>Do the insurers really pay out</stong>
          </p>
          <p>
            It’s a common concern and an enduring myth that insurers often don’t
            make pay outs. The numbers tell a different story.
          </p>
          <p>According to the Association of British Insurers (ABI):</p>
          <p>• Income Protection pays out in 98.3% of</p>
          <p>• claims Critical Illness Cover pays out in 96% of claims.</p>
          <p>
            The main reason for a policy not paying is non-disclosure this is
            when relevant medical information wasn’t fully declared during the
            application process. You might be tempted to miss something off the
            application, but if the policy provider deems that you deliberately
            misled them, they can refuse to pay out. If they consider the
            non-disclosure as careless, they can reduce the overall pay out.
          </p>
          <p>
            This is another reason why professional advice is so valuable. A
            qualified adviser ensures your disclosure is complete and accurate,
            protecting you from complications if you needed to make a claim in
            the future.
          </p>
          <p>
            <stong>The best time to protect yourself is now</stong>
          </p>
          <p>
            The earlier you put protection in place, the better. Premiums are
            lower when you’re younger and healthier, and you’re less likely to
            face exclusions for pre-existing conditions.
          </p>
          <p>
            Waiting until later can make cover more expensive and limit your
            options. It’s far more cost-effective to start while you’re fit and
            well when the insurer can spread the risk over many years.
          </p>
          <p>
            Think of protection as putting your oxygen mask on first. You spend
            your days protecting others make sure your own financial safety net
            is just as secure.
          </p>
          <p>
            <stong>Final thoughts</stong>
          </p>
          <p>
            As medics, we all know how unpredictable life can be. Illness,
            injury, or burnout can happen to anyone no matter how resilient you
            are.
          </p>
          <p>
            The NHS offers solid short-term sick pay, but it’s not designed to
            support you for years. Income Protection and Critical Illness Cover
            together offer a realistic, sustainable way to protect your
            livelihood, your family, and your peace of mind.
          </p>
          <p>
            If reading this article has made you wonder whether you have enough
            protection in place, or whether your current policies still reflect
            your situation, it’s definitely worth reviewing them.
          </p>
          <p>
            Foundations Financial Planning are specialists in helping NHS
            doctors understand and optimise their protection, pensions, and
            overall financial wellbeing. Contact us at morris@foundationsfp.com
            to discuss your situation in more detail.
          </p>
        </div>
        <Button
          text="CONTACT US"
          variant="primary"
          onClick={() => navigate("/contact")}
        />
      </div>
    </div>
  );
};

export default Blog3;
